import { render } from "./HelpNotification.vue?vue&type=template&id=f348d608"
import script from "./HelpNotification.vue?vue&type=script&lang=js"
export * from "./HelpNotification.vue?vue&type=script&lang=js"

import "./HelpNotification.vue?vue&type=style&index=0&id=f348d608&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/HelpNotification.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f348d608"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f348d608', __exports__)) {
    api.reload('f348d608', __exports__)
  }
  
  module.hot.accept("./HelpNotification.vue?vue&type=template&id=f348d608", () => {
    api.rerender('f348d608', render)
  })

}


export default __exports__